import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { findPreorder, updatePreorder } from '../service/OrdersService';

const UserAddressScreen = ({ user }) => {
  const [userAddress, setUserAddress] = useState({
    address: '',
    flat: '',
    city: '',
    postalCode: '',
    country: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();
  const params = useParams();
  const preorderId = params.id;

  useEffect(() => {
    if (user) {
      findPreorder(preorderId).then((preorder) => {
        if (!preorder[0].user) {
          navigate('/user-info');
        }
        if (preorder[0]?.user && preorder[0].userAddress) {
          setUserAddress({
            address: preorder[0].userAddress.address,
            flat: preorder[0].userAddress.flat,
            city: preorder[0].userAddress.city,
            postalCode: preorder[0].userAddress.postalCode,
            country: preorder[0].userAddress.country,
          });
        } else {
          setUserAddress({
            address: user.address,
            flat: user.flat,
            city: user.city,
            postalCode: user.zipCode,
            country: user.country,
          });
        }
        setLoading(false);
      });
    }
  }, [user]);

  const handleUserAddress = (e) => {
    setUserAddress({ ...userAddress, [e.name]: e.value });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    updatePreorder({ userAddress: userAddress }, preorderId)
      .then(() => navigate(`/delivery/${preorderId}`))
      .catch((error) => setError(error.response.data.message));
  };
  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex justify-content-center align-items-center mt-md-5'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <form
            className='Login col-md-8 col-lg-4 col-11'
            onSubmit={submitHandler}
          >
            <h6>DIRECCIÓN DEL USUARIO</h6>
            <input
              type='text'
              placeholder='Introducir dirección'
              value={userAddress.address}
              name='address'
              required
              onChange={(e) => handleUserAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir piso'
              value={userAddress.flat}
              name='flat'
              required
              onChange={(e) => handleUserAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir ciudad'
              value={userAddress.city}
              name='city'
              required
              onChange={(e) => handleUserAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir código postal'
              value={userAddress.postalCode}
              name='postalCode'
              required
              onChange={(e) => handleUserAddress(e.target)}
            />
            <input
              type='text'
              placeholder='Introducir país'
              value={userAddress.country}
              name='country'
              required
              onChange={(e) => handleUserAddress(e.target)}
            />
            <button
              disabled={
                !userAddress.address?.length > 0 ||
                !userAddress.flat?.length > 0 ||
                !userAddress.city?.length > 0 ||
                !userAddress.postalCode?.length > 0 ||
                !userAddress.country?.length > 0
              }
              style={{
                backgroundColor:
                  (!userAddress.address?.length > 0 ||
                    !userAddress.flat?.length > 0 ||
                    !userAddress.city?.length > 0 ||
                    !userAddress.postalCode?.length > 0 ||
                    !userAddress.country?.length > 0) &&
                  'grey',
              }}
              type='submit'
            >
              Continuar
            </button>
          </form>
        )}
      </div>
    </>
  );
};

export default UserAddressScreen;
